import AuthStorage from "./types/Storage"

export default class Storage<T> implements AuthStorage {
  key: string

  constructor(key: string) {
    this.key = key
  }

  get: AuthStorage<T>["get"] = async () => {
    const item = localStorage.getItem(this.key)
    return JSON.parse(item || "{}")
  }

  set: AuthStorage<T>["set"] = async (auth) => {
    localStorage.setItem(this.key, JSON.stringify(auth))
    return true
  }

  clear: AuthStorage<T>["clear"] = async () => {
    localStorage.setItem(this.key, "{}")
    return true
  }
}
